import(/* webpackMode: "eager", webpackExports: ["WindowManager"] */ "/Users/theopak/git/theopak.com/components/WindowManager.tsx");
